import { render, staticRenderFns } from "./PlayGame.vue?vue&type=template&id=4d05e71a&scoped=true&"
import script from "./PlayGame.vue?vue&type=script&lang=js&"
export * from "./PlayGame.vue?vue&type=script&lang=js&"
import style0 from "./PlayGame.vue?vue&type=style&index=0&id=4d05e71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05e71a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
